<template>
  <div :class="['relative', 'grid lg:grid-cols-2 grid-cols-1', 'overflow-hidden']">
    <!-- 左侧容器 -->
    <div
      :class="[
        'relative z-1',
        // 让小容器右对齐
        'flex justify-center items-center',
        'size-full min-h-120',
        'lg:p-24 px-4 py-24',
        // 渐变遮挡块
        'before:lg:flex before:hidden',
        'before:absolute before:top-0',
        'before:bg-secondary before:h-full',
        'before:w-60 before:right-0 before:translate-x-full',
        'before:mask-r-from-0% before:mask-r-to-50%',
      ]"
    >
      <!-- 左侧真实内容容器 -->
      <div :class="['flex justify-center items-center', 'size-full']">
        <CommonBanner
          :title="t('page.index.business.fragment.title')"
          :content="t('page.index.business.fragment.desc')"
          :centered="false"
          :has-padding="false"
          theme="dark"
        />
      </div>
    </div>

    <!-- 右侧容器 -->
    <div :class="['size-full overflow-hidden', 'lg:static absolute']">
      <Motion
        :initial="{ opacity: 0, x: 120 }"
        :while-in-view="{ opacity: 1, x: 0 }"
        :transition="{
          type: 'spring',
          stiffness: 20,
          damping: 10,
        }"
        :in-view-options="{
          once: true,
        }"
        class="size-full"
      >
        <!-- 图片 -->
        <NuxtImg
          src="/img/index/transportation-map-red.png"
          draggable="false"
          :class="[
            'lg:static absolute',
            'lg:brightness-100 brightness-70',
            'size-full object-cover',
            'object-cover hover:scale-105 transition-[scale] duration-500',
          ]"
        />
      </Motion>
    </div>
  </div>
</template>

<script lang="ts" setup>
  const { t } = useI18n()
</script>
